/**
 * Country codes for phone number buttons (code, label, dial code)
 */
// 
export const COUNTRY_CODES = [
  { code: "IN", label: "India", dialCode: "+91" },
  { code: "US", label: "United States", dialCode: "+1" },
  { code: "GB", label: "United Kingdom", dialCode: "+44" },
  { code: "AE", label: "United Arab Emirates", dialCode: "+971" },
  { code: "AU", label: "Australia", dialCode: "+61" },
  { code: "CA", label: "Canada", dialCode: "+1" },
  { code: "DE", label: "Germany", dialCode: "+49" },
  { code: "FR", label: "France", dialCode: "+33" },
  { code: "SG", label: "Singapore", dialCode: "+65" },
  { code: "MY", label: "Malaysia", dialCode: "+60" },
  { code: "SA", label: "Saudi Arabia", dialCode: "+966" },
  { code: "ZA", label: "South Africa", dialCode: "+27" },
  { code: "BR", label: "Brazil", dialCode: "+55" },
  { code: "MX", label: "Mexico", dialCode: "+52" },
  { code: "ES", label: "Spain", dialCode: "+34" },
  { code: "IT", label: "Italy", dialCode: "+39" },
  { code: "NL", label: "Netherlands", dialCode: "+31" },
  { code: "PK", label: "Pakistan", dialCode: "+92" },
  { code: "BD", label: "Bangladesh", dialCode: "+880" },
  { code: "NG", label: "Nigeria", dialCode: "+234" },
  { code: "KE", label: "Kenya", dialCode: "+254" },
  { code: "EG", label: "Egypt", dialCode: "+20" },
  { code: "ID", label: "Indonesia", dialCode: "+62" },
  { code: "PH", label: "Philippines", dialCode: "+63" },
  { code: "VN", label: "Vietnam", dialCode: "+84" },
  { code: "TH", label: "Thailand", dialCode: "+66" },
  { code: "JP", label: "Japan", dialCode: "+81" },
  { code: "KR", label: "South Korea", dialCode: "+82" },
  { code: "CN", label: "China", dialCode: "+86" },
  { code: "RU", label: "Russia", dialCode: "+7" },
  { code: "TR", label: "Turkey", dialCode: "+90" },
  { code: "PL", label: "Poland", dialCode: "+48" },
  { code: "PT", label: "Portugal", dialCode: "+351" },
  { code: "GR", label: "Greece", dialCode: "+30" },
  { code: "SE", label: "Sweden", dialCode: "+46" },
  { code: "NO", label: "Norway", dialCode: "+47" },
  { code: "DK", label: "Denmark", dialCode: "+45" },
  { code: "FI", label: "Finland", dialCode: "+358" },
  { code: "IE", label: "Ireland", dialCode: "+353" },
  { code: "NZ", label: "New Zealand", dialCode: "+64" },
  { code: "AR", label: "Argentina", dialCode: "+54" },
  { code: "CL", label: "Chile", dialCode: "+56" },
  { code: "CO", label: "Colombia", dialCode: "+57" },
  { code: "PE", label: "Peru", dialCode: "+51" },
  { code: "GH", label: "Ghana", dialCode: "+233" },
  { code: "ET", label: "Ethiopia", dialCode: "+251" },
  { code: "TZ", label: "Tanzania", dialCode: "+255" },
  { code: "UG", label: "Uganda", dialCode: "+256" },
  { code: "OTHER", label: "Other", dialCode: "" },
];
